// extracted by mini-css-extract-plugin
export default {"section3":"section3_section3__Ul18k","flex_col":"section3_flex_col__TJNEb","image1":"section3_image1__CiRvF","image":"section3_image__g+1gf","image11":"section3_image11__DTsT6"};